import React, { useMemo } from 'react';
import HeaderLogo from 'components/common/headerLogo';
import Spinner from 'components/spinner/Spinner';
import MetaTag from 'components/meta';
import { useRouter } from 'next/router';
import useAppointmentCommunique from 'hooks/useAppointmentCommunique';
import { isTabletBaseIntake } from 'env';
import { getLinkQueryParams } from 'utils/helper';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import isNil from 'lodash/isNil';
import useCommuniqueState from 'hooks/useCommuniqueState';
import { NullableAppointmentDetails } from 'types/types';
import IntakeCompletionStatus from 'components/patient/intakeCompletionStatus';

function PatientEntryScreen() {
  const router = useRouter();
  const { token } = getLinkQueryParams(router.query);
  const { errorMessage, isLoading, noModuleExists } = useAppointmentCommunique();
  const { communiqueData } = useCommuniqueState();
  const { appointmentToken } = useSelector((state: RootState) => state.appStateSettings);
  const appointmentData = useSelector(
    (state: RootState) => state.appointment,
  ) as NullableAppointmentDetails;
  const isTablet = isTabletBaseIntake || !isNil(appointmentToken);

  const pageTitle = useMemo(() => (communiqueData?.organizationName
    ? `Welcome to ${communiqueData?.organizationName}`
    : 'Welcome to Populate Intake App'), [communiqueData]);

  const canProceedToConsentForms = communiqueData?.sendForms?.consentForm;
  const showUnavailableError = noModuleExists && !canProceedToConsentForms;

  return (
    <div className="app-page-container px-4 sm:px-6">
      <MetaTag title={pageTitle} />
      <HeaderLogo />
      {errorMessage && <p className="error-message px-1">{errorMessage}</p>}
      <div className="mt-4 pb-6">
        {isLoading ? (
          <div className="flex justify-center items-center, h-[75vh]">
            <Spinner />
          </div>
        ) : (
          <div className="mt-2 text-sm">
            {showUnavailableError
              ? (
                <IntakeCompletionStatus
                  appointmentData={appointmentData}
                  communiqueData={communiqueData}
                />
              )
              : (!token && !isTablet && !canProceedToConsentForms)
                && (
                <p className="px-1 text-center text-red-600">
                  This link is not valid. Please try to visit a correct link.
                </p>
                )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PatientEntryScreen;
